import axios from 'axios';
import { apiUrl } from "../Constants/constants";

const instance = axios.create({
  baseURL: apiUrl,
  headers: {
    get: {
      "Content-Type": "application/json"
    }
  }
});

async function apiGet(query) {
  const result = await instance.get(
    query,
  );
  return result;
}

export { apiGet }
